import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";

class Terms extends Component {
    state = {
    }

    componentDidMount() {
        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
            require("./terms.css");
        } else if (path === 'sc') {
            require("./terms_sc.css");
        } else if (path === 'tc') {
            require("./terms_sc.css");
        }
    }
    render() {
        const { t } = this.props;
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('terms-meta-title')}</title>
                    <meta name="title" content={t('terms-meta-title')} />
                    <meta name="description" content={t('terms-meta-description')} />
                    <meta name="keywords" content={t('terms-meta-keywords')} />
                </MetaTags>
                <div id="div-terms">
                    <div className="terms-header">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className={t('terms-header-text TXT_medium')}>{t('terms-title')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="terms-content">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className={t('terms-content-headline TXT_bold')}>{t('terms-headline-1')}</div>
                                <div className="terms-content-sub-content">{t('terms-content-sub-content-1-1')}<span className={t('TXT_bold')}>{t('terms-content-sub-content-1-2')}</span>{t('terms-content-sub-content-1-3')}<span className={t('TXT_bold')}>{t('terms-content-keyword-2')}</span>{t('terms-content-sub-content-1-4')}<span className={t('TXT_bold')}>{t('terms-content-keyword-1')}</span>{t('terms-content-sub-content-1-5')}</div>
                                <div className={t('terms-content-sub-headline TXT_bold')}>{t('terms-sub-headline-1')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-2-1')}</span>{t('terms-content-sub-content-2-2')}<span className={t('TXT_bold')}>{t('terms-content-keyword-1')}</span>{t('terms-content-sub-content-2-3')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-3-1')}</span>{t('terms-content-sub-content-3-2')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-4-1')}</span>{t('terms-content-sub-content-4-2')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-5-1')}</span>{t('terms-content-sub-content-5-2')}<span className={t('TXT_bold')}>{t('terms-content-keyword-1')}</span>{t('terms-content-sub-content-5-3')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-6-1')}</span>{t('terms-content-sub-content-6-2')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-7-1')}</span>{t('terms-content-sub-content-7-2')}<span className={t('TXT_bold')}>{t('terms-content-keyword-1')}</span>{t('terms-content-sub-content-7-3')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-8-1')}</span>{t('terms-content-sub-content-8-2')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-9-1')}</span>{t('terms-content-sub-content-9-2')}<span className={t('TXT_bold')}>{t('terms-content-keyword-1')}</span>{t('terms-content-sub-content-9-3')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-10-1')}</span>{t('terms-content-sub-content-10-2')}<span className={t('TXT_bold')}>{t('terms-content-keyword-2')}</span>{t('terms-content-sub-content-10-3')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-11-1')}</span>{t('terms-content-sub-content-11-2')}</div>
                                <div className="terms-content-sub-content"><span className={t('TXT_bold')}>{t('terms-content-sub-content-12-1')}</span>{t('terms-content-sub-content-12-2')}</div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Terms);



// WEBPACK FOOTER //
// ./src/components/pages/terms.js